module.exports = __webpack_public_path__ + "img/portrait-008.f009bd5c.jpg";